<script lang="ts" setup>
import { inject } from 'vue';
import CollapseFieldset from '@/components/CollapseFieldset.vue';

import type { Ref } from 'vue';
import type { IManifest } from '@/types/IManifest';

const manifest = inject('manifest') as Ref<IManifest>;
const customProperties = inject('customProperties') as Ref<Map<string, unknown>>;

const renameProperty = (currentName: string, newName: string) => {
  if (newName === '') return;
  if (currentName === newName) return;

  if (!customProperties.value.has(newName)) {
    customProperties.value.set(newName, customProperties.value.get(currentName));
  }

  deleteCustomProperty(currentName);
};

const updateCustomProperty = (event: Event) => {
  const { target } = event;

  if (!(target instanceof HTMLInputElement)) return;

  const name = target.getAttribute('name') as string;
  const { value } = target;

  if (name === '') return;

  customProperties.value.set(name, value);
};

const deleteCustomProperty = (name: string) => {
  if (name === '') return;

  customProperties.value.delete(name);
  delete manifest.value[name as keyof IManifest];
};
</script>

<template>
  <CollapseFieldset>
    <template #legend>
      Custom Properties
    </template>

    <CollapseFieldset v-for="key in customProperties.keys()" :key="key" :collapse="false" :enable-collapse="false">
      <template #legend>
        {{ key }}
      </template>

      <div class="flex flex-row mb-1 items-center">
        <label class="text-xs mr-2">Name</label>
        <input class="border px-1 py-0.5 text-xs flex-grow" type="text" :value="key" @blur="(e: FocusEvent) => renameProperty(key, (e.target as HTMLInputElement).value)">
      </div>
      <div class="flex flex-row mb-1 items-center last-of-type:mb-0">
        <label class="text-xs mr-2">Value</label>
        <input class="border px-1 py-0.5 text-xs flex-grow" type="text" :name="key" :value="customProperties.get(key)" @change="updateCustomProperty">
      </div>

      <button type="button" class="text-xs p-1 bg-red-500 text-white my-1 w-full" @click="deleteCustomProperty(key)">
        Delete
      </button>
    </CollapseFieldset>
  </CollapseFieldset>
</template>
